module.exports = __webpack_public_path__ + "img/cmg-labs-2.30e5da24.webp";